import React from "react";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

export default function AddToMyCoursesButton(props) {
  const { disabled, onAddToCourses } = props;
  const { t } = useTranslation();
  return (
    <Box my={3}>
      <Button
        variant="contained"
        color="primary"
        disabled={disabled}
        onClick={onAddToCourses}
      >
        {t("librarySearch.buttons.addToMyCoursesBtn")}
      </Button>
    </Box>
  );
}

AddToMyCoursesButton.propTypes = {
  disabled: PropTypes.bool,
  onAddToCourses: PropTypes.func
};
